// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c9d1aee","89":"78de69a8","372":"f6cc16d2","718":"3dd3a559","720":"c80d686b"}[chunkId] + ".chunk.js";
};